import React,{useEffect,useState} from 'react';
import {HorizontalBar,Bar} from 'react-chartjs-2';
import {Card,CardContent,Box, Typography} from "@material-ui/core";

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  contenedorCard:{
    //paddingRight:'3rem'
    height:12+'rem',marginRight:".3rem"
  },
  card:{
    boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
    //color:'#4a4a4a',
  },
  tituloGraf:{
    paddingTop:'0rem',
    textAlign:'center'
  },
  nested: {
    paddingLeft: theme.spacing(2),
  },
}));

export default function Graficas({lista,dtoRegistro}){
  const classes = useStyles();
  const color1= '#19A11E';  //ff1744  
  const color2= '#FBBE06';
  const auxColor=process.env.REACT_APP_Fondo_Color
  const [data,setData]= useState([]);
  const [dataVotarian,setDataVotarian]= useState([]);
  const [datEdad,setDatEdad]= useState([]);
  const [bandera,setBandera]= useState(false);

  useEffect(()=>{    
    let valor=[]

    if (dtoRegistro.length ===0 ) {
      valor=lista
    }
    else{
      
      
      const filtro = lista.distritos.filter((distrito) => distrito.Dto === dtoRegistro.DtId )
      //console.log(dtoRegistro, filtro);
      if (filtro.length!==0) {
        let nvoarr={}
        nvoarr={...filtro[0], PercepBuena:filtro[0].PerpBuena, PercepMala:filtro[0].PerpMala, PercepInde:filtro[0].PerpIndec}
        valor=nvoarr
      }
      
    }
    
    setData({column1:valor.PercepBuena, column2:valor.PercepMala, column3:valor.PercepInde,
      color1:lista.Color[0].Col, color2:lista.Color[2].Col, color3:lista.Color[1].Col,
      txt1:lista.Color[0].Descr, txt2:lista.Color[2].Descr, txt3:lista.Color[1].Descr,
    })
    setDataVotarian({column1:valor.Preg01Si, column2:valor.Preg01No,//column3:valor.Preg01Indec,
      color1:lista.Color[3].Col, color2:lista.Color[4].Col, //color3:lista.Color[4].Col,
      txt1:lista.Color[3].Descr, txt2:lista.Color[4].Descr, //txt3:lista.Color[4].Descr,
    })
    
    setDatEdad({column1:valor.Edad18_25, column2:valor.Edad26_35, column3:valor.Edad36_45, column4:valor.Edad46_100,
      color1:lista.Color[16].Col, color2:lista.Color[17].Col, color3:lista.Color[18].Col, color4:lista.Color[19].Col,
      txt1:"18-25", txt2:"26-35", txt3:"36-45", txt4:"46-100",
    })

    setBandera(true)
  },[lista,dtoRegistro])

  const dataPercep = {
    labels: ['Percepción'],
    datasets: [
    { type: 'bar', label:[ data.txt1 ],
        data:[data.column1],//[10, 20, 30, 40],
        backgroundColor:  [ data.color1]//'rgba(255, 99, 132, 0.2)',         
      },              
      { label:data.txt2,
        type: 'bar',
        data: [data.column2], //[50, 40, 30, 50],
        backgroundColor:data.color2,
        borderColor: data.color2,
        //fill: false,
        tension: 0.4           
      },
      { label:data.txt3,
        type: 'bar',
        data: [data.column3], //[50, 40, 30, 50],
        backgroundColor:data.color3,
        borderColor: data.color3,
        //fill: false,
        tension: 0.4   
        
      },   
    ],
  }; 

  const dataVotar = {
    labels: ['Votarían'],
    datasets: [
    { type: 'bar', label:[ dataVotarian.txt1 ],
        data:[dataVotarian.column1],//[10, 20, 30, 40],
        backgroundColor:  [ dataVotarian.color1]//'rgba(255, 99, 132, 0.2)',         
      },              
      { label:dataVotarian.txt2,
        type: 'bar',
        data: [dataVotarian.column2], //[50, 40, 30, 50],
        backgroundColor:dataVotarian.color2,
        borderColor: dataVotarian.color2,
        //fill: false,
        tension: 0.4           
      },
     /*  { label:dataVotarian.txt3,
        type: 'bar',
        data: [dataVotarian.column3], //[50, 40, 30, 50],
        backgroundColor:dataVotarian.color3,
        borderColor: dataVotarian.color3,
        //fill: false,
        tension: 0.4   
        
      },    */
    ],
  }; 

  const dataEdad = {
    labels: ['Edad'],
    datasets: [
    { type: 'bar', label:[ datEdad.txt1 ],
        data:[datEdad.column1],
        backgroundColor:  [ datEdad.color1]         
      },              
      { label:datEdad.txt2,
        type: 'bar',
        data: [datEdad.column2],
        backgroundColor:datEdad.color2,
        borderColor: datEdad.color2,    
        tension: 0.4           
      },
      { label:datEdad.txt3,
        type: 'bar',
        data: [datEdad.column3],  
        backgroundColor:datEdad.color3,
        borderColor: datEdad.color3,     
        tension: 0.4           
      },   
      { label:datEdad.txt4,
        type: 'bar',
        data: [datEdad.column4],  
        backgroundColor:datEdad.color4,
        borderColor: datEdad.color4,     
        tension: 0.4           
      }, 
    ],
  }; 
  const options = {
  
    tooltips: {
      enabled: true,
    },

    title:{
      fontStyle: 'bold',
    },
   // animation:false,
    scales: {
      x: {
          display: true,
          title: {
          display: true
          }
      },
      y: {
          display: true,
          title: {
          display: false,
       
          },
       
      },
      }

  } 

  function  llenadoTabla2(datos,options)
  {
    return(
    <Card className={classes.card} style={{paddingRight:.8+'rem',paddingLeft:.8+'rem' 
      ,paddingBottom:.5+'rem',height:11+'rem',width:20+'rem'}} >              
      <Bar
        id="graficaMuni"
        data={datos}
        width={380} height={240} 
        options={options}
      />   
    </Card>
    );
  }

  function  llenadoTabla(datos,options)
  {
    return(
    <Card className={classes.card} style={{paddingRight:.8+'rem',paddingLeft:.8+'rem' 
      ,paddingBottom:.5+'rem',height:11+'rem',width:22+'rem'}} >              
      <Bar
        id="graficaMuni"
        data={datos}
        width={400} height={240} 
        options={options}
      />   
    </Card>
    );
  }

  return (
  <Box display="flex" flexDirection="row" justifyContent={'center'}   >           
    <Box display="flex"className={classes.contenedorCard}  >
      {bandera ?llenadoTabla2(dataPercep,options):null}
    </Box>      
    <Box display="flex"className={classes.contenedorCard}  >
      {bandera ?llenadoTabla2(dataVotar,options):null}
    </Box> 
      <Box display="flex"className={classes.contenedorCard}  >
      {bandera ?llenadoTabla(dataEdad,options):null}
    </Box>    
  </Box>
  );
}